import { configureStore } from "@reduxjs/toolkit";
import AuthSlice from "./AuthSlice";
import RestaurantsSlice from "./RestaurantsSlice";
import ProductSlice from "./ProductSlice";
import OffersSlice from "./OffersSlice";
import StstisticsSlice from "./StstisticsSlice";

export default configureStore({
  reducer: {
    AuthSlice,
    OffersSlice,
    RestaurantsSlice,
    ProductSlice,
    StstisticsSlice,
  },
});
